import {CHECKIN_STATUS, FARES_FAMILY, FLIGHT_STATUS, MARKET_FLIGHT, REGION_KEY} from "@app/enums";
import {
  AncillaryInt,
  BookedLegInt,
  BookedSegmentInt,
  BookedTravelerCollectionInt,
  SegmentInt,
  Segments,
  iropEligibilityInt
} from "@interfaces/*";
import {Segment} from "@models/micro";

export class FlightSummary {

  legCode: string;
  legEntity: string;
  legRegion: string;
  cartId: string;
  currencyCode: string;
  serverCartTotal: number;
  isDomestic: boolean;
  seatSelectionType: string;
  marketFlight: MARKET_FLIGHT;
  checkInRestrictedByStandbyConstraint: boolean;
  checkinStatus: CHECKIN_STATUS;
  operatedByAm: boolean;
  totalFlightTimeInHours: number;
  totalFlightTimeInMinutes: number;
  flightHours: number;
  flightMinutes: number;
  boardingGate: string;
  boardingTerminal: string;
  boardingTime: string;
  regionKey: REGION_KEY;
  totalBoardTimeInHours: number;
  boardHours: number;
  boardMinutes: number;
  departureTime: string;
  departureDateTime: Date;
  pallTotalListed: number;
  currentSegment: SegmentInt;
  infoToFly: string;
  flightNumber: string;
  departureAirport: string;
  departureCity: string;
  arrivalAirport: string;
  arrivalCity: string;
  operatingCarrier: string;
  fareFamily: FARES_FAMILY;
  segments: Segments;
  unpaidAncillaries: AncillaryInt[];
  bookingCabin: string;
  flightStatus: FLIGHT_STATUS;
  iropEligibility: iropEligibilityInt;
  itineraryPartType: string;


  constructor(cart: BookedTravelerCollectionInt, leg: BookedLegInt, kioskLocation: string) {
    const premierFares = ['J', 'F', 'C', 'D', 'I', 'Z', 'O'];
    this.legCode = cart?.legCode;
    this.cartId = cart?._meta.cartId;
    if ( cart?._meta && cart?._meta.total && cart?._meta.total.currency ) {
      this.currencyCode = cart?._meta.total.currency.currencyCode;

      this.serverCartTotal = cart?._meta.total.currency.total;
    }
    this.isDomestic = leg?.domestic;

    this.legEntity = leg?.legEntity;
    this.legRegion = leg?.legRegion;
    this.seatSelectionType = leg?.seatSelectionType;
    this.marketFlight = leg?.marketFlight;
    this.checkInRestrictedByStandbyConstraint = leg?.checkInRestrictedByStandbyConstraint;

    this.itineraryPartType = leg?.itineraryPartType;

    const segments = leg?.segments;

    if ( segments.legCode === cart?.legCode ) {

      const currentSegment = this.getCurrentSegment(segments?._collection, kioskLocation);
      this.currentSegment = currentSegment;
      let departureDate = currentSegment.departureDateTime;

      if (currentSegment.estimatedDepartureTime) {
        departureDate = currentSegment.estimatedDepartureTime;
      }

      const flightStatus = currentSegment.flightStatus || currentSegment?.flightStatus;

      if ( !currentSegment || !flightStatus ) {
        this.flightStatus = FLIGHT_STATUS.UNKNOWN;
      }
      else {
        this.flightStatus = flightStatus;
      }
     
      if ( leg.checkinStatus === "CLOSED" || leg.checkinStatus === "CLOSED_NOT_OPERATED_BY_AM" || leg.checkinStatus === "CLOSED_DOMESTIC_WINDOW" || leg.checkinStatus === "CLOSED_INTERNATIONAL_WINDOW" ) {
        this.checkinStatus = CHECKIN_STATUS.CLOSED;
      } else if ( leg.checkinStatus.indexOf('CLOSED_GROUND_HANDLING_BY_') !== -1 ) {
        this.checkinStatus = CHECKIN_STATUS.CLOSED_GROUND_HANDLING_BY_AF;
      }

      if (!this.checkinStatus) this.checkinStatus = currentSegment.checkinStatus;

      this.operatedByAm = leg.checkinStatus !== "CLOSED_NOT_OPERATED_BY_AM";
      this.legCode = segments.legCode;
      this.totalFlightTimeInMinutes = segments.totalFlightTimeInMinutes;
      if ( this.totalFlightTimeInMinutes == null ) {
        this.totalFlightTimeInMinutes = 0;
      }
      this.totalFlightTimeInHours = Number((segments.totalFlightTimeInMinutes / 60).toFixed(1));
      this.flightHours = Math.floor(this.totalFlightTimeInHours);
      this.flightMinutes = Number(segments.totalFlightTimeInMinutes) % 60;
      this.boardingGate = leg.boardingGate;
      this.boardingTerminal = leg.boardingTerminal;
      this.boardingTime = leg.boardingTime;
      if(leg.regionKey != null){
        this.regionKey = leg.regionKey
      }
      if ( leg.remainingTimeToBoard != null ) {
        this.totalBoardTimeInHours = Number((Number(leg.remainingTimeToBoard) / 60).toFixed(1));
        this.boardHours = Math.floor(this.totalBoardTimeInHours);
        this.boardMinutes = Number(leg.remainingTimeToBoard) % 60;
      } else {
        this.totalBoardTimeInHours = 0;
        this.boardHours = 0;
        this.boardMinutes = 0;
      }

      this.departureTime = this.getTime(departureDate);
      this.departureDateTime = departureDate;

      if ( leg.boardingTime != null ) {
        this.infoToFly = 'Boarding';
      } else {
        this.boardingTime = '';
        this.infoToFly = 'Boarding.Soon';
      }

      if ( segments && segments._collection && segments._collection.length > 0 ) {
        var firstSegment = segments._collection[0].segment;
        var lastSegment = segments._collection[segments._collection.length - 1].segment;
        this.flightNumber = firstSegment.operatingCarrier + " " + firstSegment.operatingFlightCode;
        this.departureAirport = firstSegment.departureAirport;
        this.departureCity = this.getCityName(this.departureAirport);
        this.arrivalAirport = lastSegment.arrivalAirport;
        this.arrivalCity = this.getCityName(this.arrivalAirport);
        this.operatingCarrier = firstSegment.operatingCarrier;
        this.fareFamily = firstSegment.fareFamily;
        firstSegment.bookingClass

        if (!firstSegment.fareFamily) {
          const {bookingClass} = firstSegment;
          if (premierFares.indexOf(bookingClass) > -1) {
            this.fareFamily = FARES_FAMILY.PREMIER;
          }else if(bookingClass?.toLocaleUpperCase() === "W"){
            this.fareFamily = FARES_FAMILY.AMPLUS;
          }else if(bookingClass?.toLocaleUpperCase() === "V"){
            this.fareFamily = FARES_FAMILY.BASIC;
          }else{
            this.fareFamily = FARES_FAMILY.CLASSIC
          }
        }
        for (const element of segments._collection) {
          element.segment.iropEligibility = leg.iropEligibility;
        }
        this.segments = segments;
      }

      this.unpaidAncillaries = [];
      if ( cart?.travelerInfo != null && cart?.travelerInfo._collection != null ) {
        for ( let traveler of cart?.travelerInfo._collection){
          if ( traveler.ancillaries != null && traveler.ancillaries._collection != null ) {
            for (let ancillary of traveler.ancillaries._collection) {
              if ( ancillary != null && ancillary.currency != null && ancillary.currency.total != null && ancillary.currency.total > 0 ) {
                this.unpaidAncillaries.push(ancillary);
              }
            }
          }
        }

        if ( cart?.travelerInfo._collection && cart?.travelerInfo._collection.length > 0 ) {
          let traveler = cart?.travelerInfo._collection[0];
          if ( traveler.bookingClasses != null && traveler.bookingClasses._collection != null && traveler.bookingClasses._collection.length && traveler.bookingClasses._collection.length > 0 ) {
            var bookingClass = traveler.bookingClasses._collection[0];
            this.bookingCabin = bookingClass.bookingCabin;
          }
        }
      }
    }
  }

  private getCurrentSegment(segments: BookedSegmentInt[], kioskLocation: string): SegmentInt {
    for ( var idx = 0; idx < segments.length; idx++ ) {
      var segment = segments[idx].segment;

      var isSameAirport = kioskLocation === segment.departureAirport;

      if ( isSameAirport ) {
        return segment;
      }
    }

    return segments[segments.length - 1].segment;

  }

  private getTime(dateTime) {
    var time = '';

    if ( dateTime != null ) {
      var timeIndex = dateTime.indexOf('T');
      if ( timeIndex != -1 ) {
        timeIndex++;
      }

      time = dateTime.substring(timeIndex, 5);
    }

    return time;
  }

  private getCityName(airportCode) {
    var cityName = "";

    try {
      cityName = "" ;
    } catch (e) {
    }

    return cityName;
  }


}
